import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const ghatkopar: AreaConfig = {
  name: 'Ghatkopar',
  slug: 'ghatkopar',
  tagline: 'Doorstep Mobile Repair in Ghatkopar, Mumbai',
  description:
    'Central line meets Metro at Ghatkopar. minto sends a certified technician to your home or office in Ghatkopar East or West, Vikhroli, Bhandup, or Mulund — phone repaired in under an hour without a shop visit.',
  localities: [
    'Ghatkopar East', 'Ghatkopar West', 'Vikhroli East', 'Vikhroli West',
    'Bhandup East', 'Bhandup West', 'Mulund East', 'Mulund West',
    'Nahur', 'Ramabai Colony', 'Asalpha', 'Pant Nagar', 'Sakinaka',
  ],
  zones: [
    {
      name: 'Ghatkopar East & West',
      line: 'Central Line',
      station: 'Ghatkopar Station / Ghatkopar Metro',
      localities: ['Ghatkopar East', 'Ghatkopar West', 'Tilak Nagar', 'Pant Nagar', 'Asalpha', 'Ramabai Colony', 'R.C. Marg'],
      desc: 'Ghatkopar is a major Central line hub with Metro connectivity. Our technicians cover both east and west side societies and offices.',
    },
    {
      name: 'Vikhroli',
      line: 'Central Line',
      station: 'Vikhroli Station',
      localities: ['Vikhroli East', 'Vikhroli West', 'Godrej Hill', 'Pipeline Road', 'Sakinaka', 'MIDC Andheri adjacent'],
      desc: 'Vikhroli East (Godrej Township) and West fully covered. Our technicians visit corporate offices on Godrej Hill and residential buildings in Vikhroli West.',
    },
    {
      name: 'Bhandup & Mulund',
      line: 'Central Line',
      station: 'Bhandup Station / Nahur Station / Mulund Station',
      localities: ['Bhandup West', 'Bhandup East', 'Nahur', 'Mulund West', 'Mulund East', 'Mulund Colony', 'LBS Marg'],
      desc: 'Covering the northern Central line suburbs from Bhandup to Mulund. Both east and west sides of all stations are served.',
    },
  ],
  seo: {
    title: 'Mobile Repair in Ghatkopar | Doorstep Phone Repair | minto',
    description:
      'Doorstep mobile repair in Ghatkopar East & West, Vikhroli, Bhandup & Mulund, Mumbai. Screen replacement, battery repair. Certified technicians, 90-day warranty. Book now!',
    keywords:
      'mobile repair Ghatkopar, phone repair Ghatkopar, screen repair Ghatkopar, battery replacement Ghatkopar, iPhone repair Ghatkopar, Samsung repair Ghatkopar, Vikhroli phone repair, Bhandup mobile repair, Mulund phone repair, doorstep repair Ghatkopar, Central line mobile repair',
  },
  faqs: [
    {
      q: 'Do you offer doorstep repair in Ghatkopar East?',
      a: 'Yes, we cover Ghatkopar East including Tilak Nagar, Pant Nagar, and Ramabai Colony.',
    },
    {
      q: 'Can you repair phones in Vikhroli near Godrej Hill?',
      a: 'Yes, Vikhroli East (Godrej Township) and West are both covered. We visit offices and homes in Vikhroli.',
    },
    {
      q: 'Do you also serve Bhandup and Mulund?',
      a: 'Yes! Bhandup West, Bhandup East, Mulund West, and Mulund East are all part of our Ghatkopar service zone.',
    },
    {
      q: 'How much does screen repair cost in Ghatkopar?',
      a: 'Screen repair starts from ₹999 depending on your device. Check exact pricing on the booking page.',
    },
    {
      q: 'Is there a warranty for repairs done in Ghatkopar?',
      a: 'All repairs carry a 90-day warranty. Same-issue repairs are free within the warranty period.',
    },
  ],
};

const GhatkoparPage: React.FC = () => <AreaLandingPage area={ghatkopar} />;
export default GhatkoparPage;
